import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import ManageClinic from "./ManageClinic";
import { useCODData } from "../../context/CODDataContext";
import {
  useGetDashboardStatus,
  useSendDeviceId,
} from "../../hooks/useProvider";
import useToken from "../../hooks/useToken";

import { useEffect, useRef } from "react";
import useSound from "use-sound";

const MainMenu = ({ providerData, clinicData }) => {
  const location = useLocation();
  const { token } = useToken();
  const hideMenu =
  location.pathname.startsWith("/scribe-service-details") ||
  location.pathname.startsWith("/nurse/scribe-service-details");
  const { isWaiting, isSafWaiting, isSoNotComplete } = useCODData();
  const { mutate: senDeviceId } = useSendDeviceId();
  const { data: menuData } = useGetDashboardStatus();
  const showAlert =
    (isWaiting || isSafWaiting || isSoNotComplete) &&
    !location.pathname.includes("/consultations") &&
    !location.pathname.includes("/consultation");

  const restrictedPaths = ["/consultations", "/consultation"];
  const shouldPlaySound =
    providerData?.internalProvider === true &&
    !restrictedPaths.some((path) => location.pathname.includes(path));

  // Ref to store the previous state
  const previousStatusRef = useRef({});

  useEffect(() => {
    if (clinicData?.status === "SUCCESS" && clinicData?.clinicProvider) {
      localStorage?.setItem(
        "clinicId",
        clinicData?.clinicProvider[0]?.clinicId
      );
    }
  }, [clinicData]);

  const [playEmergencyCare] = useSound(
    process.env.REACT_APP_ALERTU_NOTIFICATION,
    {
      volume: 0.9,
    }
  );
  const [playJingle] = useSound(process.env.REACT_APP_JINGLE_NOTIFICATION, {
    volume: 0.9,
  });

  useEffect(() => {
    if (!providerData?.internalProvider) return; // Ensure sound plays only for internalProvider

    const currentStatus = menuData?.agentDashboardMenuStatus || {};

    const playSounds = () => {
      if (!shouldPlaySound) return;

      // Play specific sound only if the count increased
      if (
        currentStatus.emergencyCareReq > 0 &&
        currentStatus.emergencyCareReq !==
          previousStatusRef.current.emergencyCareReq
      ) {
        playEmergencyCare();
      }

      // Update the previous status
      previousStatusRef.current = { ...currentStatus };
    };

    // Play sounds on state update
    playSounds();

    // Prevent the jingle logic if the path is restricted
    if (!shouldPlaySound) return;

    // Start the interval after the initial timeout
    const jingleInterval = setInterval(() => {
      if (currentStatus.emergencyCareReq > 0) {
        playJingle();
      }
    }, 37000);

    // Clear interval on unmount
    return () => clearInterval(jingleInterval);
  }, [
    menuData?.agentDashboardMenuStatus,
    location.pathname,
    shouldPlaySound,
    playEmergencyCare,
    playJingle,
    providerData?.internalProvider,
  ]);

  useEffect(() => {
    if (token) {
      const tokenObj = {
        deviceToken: token,
        deviceId: "1234",
        userId: providerData?.id,
        deviceType: "web",
      };

      senDeviceId(tokenObj);
    }
  }, [token, providerData?.id, senDeviceId]);

  return (
    // <>
    //   {providerData?.avialableForOthers === true ? (
    //     <Link
    //       to="/dashboard"
    //       className={
    //         location.pathname.includes("/dashboard") ? "sidebar_active" : ""
    //       }
    //     >
    //       {isWaiting && <div className={showAlert ? "red__alert" : ""}></div>}
    //       Home
    //     </Link>
    //   ) : (
    //     <Link
    //       to={
    //         providerData?.eligibleForExpertAnalysis
    //           ? "/second-opinion"
    //           : "/skincare-saf"
    //       }
    //       className={
    //         location.pathname.includes(
    //           providerData?.eligibleForExpertAnalysis
    //             ? "/second-opinion"
    //             : "/skincare-saf"
    //         )
    //           ? "sidebar_active"
    //           : ""
    //       }
    //     >
    //       {(isSafWaiting || isSoNotComplete) && (
    //         <div className={showAlert ? "red__alert" : ""}></div>
    //       )}
    //       Home
    //     </Link>
    //   )}
    //   <Link
    //     to="/my-consultations"
    //     className={
    //       location.pathname.includes("/my-consultations")
    //         ? "sidebar_active"
    //         : ""
    //     }
    //   >
    //     My Consultations
    //   </Link>

    //   {providerData?.isScribeEnabled && (
    //     <Link
    //       to="/ai/scribe"
    //       className={
    //         location.pathname.includes("/ai/scribe") ? "sidebar_active" : ""
    //       }
    //     >
    //       Scribe
    //     </Link>
    //   )}

    //   <Link
    //     to="/ai/intake"
    //     className={
    //       location.pathname.includes("/ai/intake") ? "sidebar_active" : ""
    //     }
    //   >
    //     Intake
    //   </Link>

    //   {providerData?.skincareSAF === true &&
    //     providerData?.avialableForOthers === true && (
    //       //! Display only if the provider has access to skincare saf
    //       <Link
    //         to="/skincare-saf"
    //         className={
    //           location.pathname.includes("/skincare-saf")
    //             ? "sidebar_active"
    //             : ""
    //         }
    //       >
    //         {isSafWaiting && (
    //           <div className={showAlert ? "red__alert" : ""}></div>
    //         )}
    //         Skincare Case Review
    //       </Link>
    //     )}

    //   {providerData?.eligibleForExpertAnalysis &&
    //     providerData?.avialableForOthers && (
    //       <Link
    //         to="/second-opinion"
    //         className={
    //           location.pathname.includes("/second-opinion")
    //             ? "sidebar_active"
    //             : ""
    //         }
    //       >
    //         {isSoNotComplete && (
    //           <div className={showAlert ? "red__alert" : ""}></div>
    //         )}
    //         Second Opinion
    //       </Link>
    //     )}

    //   {providerData?.secondOpinionAdmin && (
    //     <Link
    //       to="/home-care"
    //       className={
    //         location.pathname.includes("/home-care") ? "sidebar_active" : ""
    //       }
    //     >
    //       Home Care
    //     </Link>
    //   )}

    //    {providerData?.internalProvider && (
    //     <Link
    //       to="/pharmacy-care"
    //       className={
    //         location.pathname.includes("/pharmacy-care") ? "sidebar_active" : ""
    //       }
    //     >
    //       Pharmacy
    //     </Link>
    //   )}    

    //   {providerData?.hasAccesstoDermaCare === true && (
    //     //! Display only if the provider has access to dermacare
    //     <Link
    //       to="/dermacare"
    //       className={
    //         location.pathname.includes("/dermacare") ? "sidebar_active" : ""
    //       }
    //     >
    //       Dermacare
    //     </Link>
    //   )}
    //   <Link
    //     to="/calander"
    //     className={
    //       location.pathname.includes("/calander") ? "sidebar_active" : ""
    //     }
    //   >
    //     Calendar
    //   </Link>
    //   <Link
    //     to="/billing"
    //     className={
    //       location.pathname.includes("/billing") ? "sidebar_active" : ""
    //     }
    //   >
    //     Payments
    //   </Link>
    //   <Link
    //     to="/patients"
    //     className={
    //       location.pathname.includes("/patients") ? "sidebar_active" : ""
    //     }
    //   >
    //     Patients
    //   </Link>

     
    //   {clinicData?.clinicProvider?.length > 0 && (
    //     <ManageClinic providerData={providerData} clinicData={clinicData} />
    //   )}
     
    // </>
    <>
  {/* Home */}
  {!hideMenu &&
    (providerData?.avialableForOthers === true ? (
      <Link
        to="/dashboard"
        className={
          location.pathname.includes("/dashboard")
            ? "sidebar_active"
            : ""
        }
      >
        {isWaiting && (
          <div className={showAlert ? "red__alert" : ""}></div>
        )}
        Home
      </Link>
    ) : (
      <Link
        to={
          providerData?.eligibleForExpertAnalysis
            ? "/second-opinion"
            : "/skincare-saf"
        }
        className={
          location.pathname.includes(
            providerData?.eligibleForExpertAnalysis
              ? "/second-opinion"
              : "/skincare-saf"
          )
            ? "sidebar_active"
            : ""
        }
      >
        {(isSafWaiting || isSoNotComplete) && (
          <div className={showAlert ? "red__alert" : ""}></div>
        )}
        Home
      </Link>
    ))}

  {/* My Consultations */}
  {!hideMenu && (
    <Link
      to="/my-consultations"
      className={
        location.pathname.includes("/my-consultations")
          ? "sidebar_active"
          : ""
      }
    >
      My Consultations
    </Link>
  )}

  {/* Scribe — stays in SAME position */}
  {providerData?.isScribeEnabled && (
    <Link
      to="/ai/scribe"
      className={
        location.pathname.includes("/ai/scribe") || hideMenu
          ? "sidebar_active"
          : ""
      }
    >
      Scribe
    </Link>
  )}

  {/* Intake */}
  {!hideMenu && (
    <Link
      to="/ai/intake"
      className={
        location.pathname.includes("/ai/intake")
          ? "sidebar_active"
          : ""
      }
    >
      Intake
    </Link>
  )}

  {/* Skincare Case Review */}
  {!hideMenu &&
    providerData?.skincareSAF &&
    providerData?.avialableForOthers && (
      <Link
        to="/skincare-saf"
        className={
          location.pathname.includes("/skincare-saf")
            ? "sidebar_active"
            : ""
        }
      >
        {isSafWaiting && (
          <div className={showAlert ? "red__alert" : ""}></div>
        )}
        Skincare Case Review
      </Link>
    )}

  {/* Second Opinion */}
  {!hideMenu &&
    providerData?.eligibleForExpertAnalysis &&
    providerData?.avialableForOthers && (
      <Link
        to="/second-opinion"
        className={
          location.pathname.includes("/second-opinion")
            ? "sidebar_active"
            : ""
        }
      >
        {isSoNotComplete && (
          <div className={showAlert ? "red__alert" : ""}></div>
        )}
        Second Opinion
      </Link>
    )}

  {/* Home Care */}
  {!hideMenu && providerData?.secondOpinionAdmin && (
    <Link
      to="/home-care"
      className={
        location.pathname.includes("/home-care")
          ? "sidebar_active"
          : ""
      }
    >
      Home Care
    </Link>
  )}

  {/* Pharmacy */}
  {!hideMenu && providerData?.internalProvider && (
    <Link
      to="/pharmacy-care"
      className={
        location.pathname.includes("/pharmacy-care")
          ? "sidebar_active"
          : ""
      }
    >
      Pharmacy
    </Link>
  )}

  {/* Dermacare */}
  {!hideMenu && providerData?.hasAccesstoDermaCare && (
    <Link
      to="/dermacare"
      className={
        location.pathname.includes("/dermacare")
          ? "sidebar_active"
          : ""
      }
    >
      Dermacare
    </Link>
  )}

  {/* Calendar */}
  {!hideMenu && (
    <Link
      to="/calander"
      className={
        location.pathname.includes("/calander")
          ? "sidebar_active"
          : ""
      }
    >
      Calendar
    </Link>
  )}

  {/* Payments */}
  {!hideMenu && (
    <Link
      to="/billing"
      className={
        location.pathname.includes("/billing")
          ? "sidebar_active"
          : ""
      }
    >
      Payments
    </Link>
  )}

  {/* Patients */}
  {!hideMenu && (
    <Link
      to="/patients"
      className={
        location.pathname.includes("/patients")
          ? "sidebar_active"
          : ""
      }
    >
      Patients
    </Link>
  )}

  {/* Manage Clinic */}
  {!hideMenu && clinicData?.clinicProvider?.length > 0 && (
    <ManageClinic
      providerData={providerData}
      clinicData={clinicData}
    />
  )}
</>

  );
};

export default MainMenu;
